import type { RouteObject } from 'react-router';
import { PricingPlansPage } from './pages/PricingPlansPage';
import { SubscriptionManagePage } from './pages/SubscriptionManagePage';
import { TierChangePage } from './pages/TierChangePage';
import { PaymentMethodPage } from './pages/PaymentMethodPage';
import { StaffFeePage } from './pages/StaffFeePage';
import { InvoiceHistoryPage } from './pages/InvoiceHistoryPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { ReferralInvitePage } from './pages/ReferralInvitePage';
import { RefundRequestPage } from './pages/RefundRequestPage';
import { withOwnerGuard } from './components/withOwnerGuard';

export const routes: RouteObject[] = [
  // 요금제 비교·선택 페이지
  { path: '/agents/billing', Component: withOwnerGuard(PricingPlansPage) },
  // 구독·결제 관리 화면
  { path: '/agents/billing/manage', Component: withOwnerGuard(SubscriptionManagePage) },
  // 티어 업그레이드·다운그레이드 화면
  { path: '/agents/billing/change-tier', Component: withOwnerGuard(TierChangePage) },
  // 결제수단 등록·변경 화면
  { path: '/agents/billing/payment-method', Component: withOwnerGuard(PaymentMethodPage) },
  // 직원 계정 추가요금 안내 (C-5)
  { path: '/agents/billing/staff-fee', Component: withOwnerGuard(StaffFeePage) },
  // 결제 내역·인보이스 화면 (C-4)
  { path: '/agents/billing/invoices', Component: withOwnerGuard(InvoiceHistoryPage) },
  // 결제 확인·진행 화면 (C-11) — C-6의 "지금 업그레이드" 진입
  { path: '/agents/billing/checkout', Component: withOwnerGuard(CheckoutPage) },
  // 추천인 초대 화면 (C-8)
  { path: '/agents/billing/referral', Component: withOwnerGuard(ReferralInvitePage) },
  // 환불 신청 화면 (C-10) — 미착수, 좌측 메뉴 링크가 죽지 않도록 준비중 안내만
  { path: '/agents/billing/refund', Component: withOwnerGuard(RefundRequestPage) },
];
